import React from 'react';
import { Link } from 'react-router-dom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import classnames from 'classnames'
import SiteLogo from '../../assets/logos/SiteLogo'

const Header = ({
    mini
}) => {

  return (
    <header className={classnames('header', { mini })}>

      {mini && (
        <Link to="/" className="header__back" aria-label="Back to home">
          <FontAwesomeIcon icon="close" />
        </Link>
      )}

      <Link to="/" className="header__logo"><SiteLogo /></Link>

      <div className="header__nav">
        <a href="https://www.linkedin.com/in/itsmedrew/" target="_blank" rel="noopener noreferrer">LinkedIn</a>
        <a href="https://www.itsmedrew.com/resume/drew-roberts_resume.pdf" target="_blank" rel="noopener noreferrer" external="true">Resume</a>
      </div>
    </header>
  );
};

export default Header;
